
<div class="section">
  <ag-grid-angular [style.height]="height + 'px'" [excelStyles]="excelStyles"
    [getContextMenuItems]="getContextMenuItems" id="myGrid" class="ag-theme-alpine app-grid-full-width"
    [domLayout]="domLayout" [rowData]="listsData" [columnDefs]="columnDefs" [skipHeaderOnAutoSize]="false"
    [headerHeight]="headerHeight"
    [floatingFilter]="floatingFilter" [isRowMaster]="isRowMaster" [groupDefaultExpanded]="groupDefaultExpanded"
    [masterDetail]="true" [sideBar]="sideBar" [modules]="modules" [detailCellRendererParams]="detailCellRendererParams"
    [tooltipShowDelay]="tooltipShowDelay" [suppressRowClickSelection]="true" (bodyScroll)="handleScroll($event)"
    [rowSelection]="rowSelection" (gridReady)="onGridReady($event)" [defaultColDef]="defaultColDef"
    [groupDisplayType]="'groupRows'" [enableRangeSelection]="true"
    [getRowHeight]="getRowHeight" [frameworkComponents]="frameworkComponents"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    (rowSelected)="onRowSelected($event)"
    [pinnedTopRowData]="pinnedTopRowData"
    [defaultExcelExportParams]="excelExportParams"
    [stopEditingWhenCellsLoseFocus]="true" 
    [defaultCsvExportParams]="csvExportParams"
    [rowClassRules]="rowClassRules"
    (rowDoubleClicked)="RowDoubleClicked($event)"
    (rowClicked)="RowClicked($event)"
    (cellDoubleClicked)="CellDoubleClicked($event)"
    [suppressCopyRowsToClipboard]="true"
    [groupUseEntireRow]="true"
    (cellValueChanged)="onCellValueChanged($event)" 
    [accentedSort]="true"
    (cellClicked)="CellClicked($event)"
    [isRowSelectable]="isRowSelectable"
    >
  </ag-grid-angular>
</div> 